<template>
  <div class="text-center">
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        color="error"
        size=150
        width=7></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    name: "LoadingOverlay",
    computed: {
        ...mapGetters(["loading"])
    }
}
</script>